<template>
  <div class="container_people">
    <div class="accountInfo_box">
      <div class="account_title">{{ $t("lang.账号信息") }}</div>
      <div class="info_box">
        <div class="info_item">
          <div>
            <i class="iconfont icon-mingcheng"></i>
            <span>{{ $t("lang.用户名称") }}</span>
            <span>{{ nickName }}</span>
          </div>
          <el-button type="primary" plain @click="onClickEditAccount(1)">{{
            $t("lang.修改")
          }}</el-button>
        </div>
        <div class="info_item">
          <div>
            <i class="iconfont icon-mima"></i>
            <span>{{ $t("lang.修改密码") }}</span>
            <span>{{ $t("lang.已设置登录密码") }}</span>
          </div>
          <el-button type="primary" plain @click="onClickEditAccount(2)">{{
            $t("lang.修改")
          }}</el-button>
        </div>
        <div class="info_item" v-loading="loadingPwd2">
          <div>
            <i class="iconfont icon-mima"></i>
            <span>{{ $t("lang.二级密码") }}</span>
            <span v-if="isSetPwd2">{{ $t("lang.已设置二级密码") }}</span>
            <span v-else>{{ $t("lang.未设置") }}</span>
            <span class="del_btn" @click="onClickDelPwd2" v-if="isSetPwd2">{{
              $t("lang.删除密码")
            }}</span>
          </div>
          <el-button type="primary" plain @click="onClickSetPwd2">{{
            isSetPwd2 ? $t("lang.修改") : $t("lang.设置")
          }}</el-button>
        </div>
      </div>
    </div>
    <AccountDialog :isSetPwd2="isSetPwd2" ref="accountDialogRef" />
    <edit-pwd2-dialog @onRefresh="iPasswordInfo" ref="editPwd2DialogRef" />
    <del-pwd2-dialog @onRefresh="iPasswordInfo" ref="delPwd2DialogRef" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AccountDialog from "./account-dialog.vue";
import EditPwd2Dialog from "./edit-pwd2-dialog.vue";
import DelPwd2Dialog from "./del-pwd2-dialog.vue";
export default {
  components: {
    AccountDialog,
    EditPwd2Dialog,
    DelPwd2Dialog,
  },
  data() {
    return {
      nickName: "",
      loadingPwd2: false,
      isSetPwd2: false,
    };
  },
  created() {
    this.nickName = JSON.parse(sessionStorage.getItem("userInfo")).username;
    this.isSetPwd2 = this.$store.getters["password/openFactorAuthent2"];
  },
  methods: {
    ...mapActions({
      passwordInfo: "ZD_SecurityPasswordInfo",
    }),
    async iPasswordInfo() {
      try {
        this.loadingPwd2 = true;
        let res = await this.passwordInfo();
        if (res.success !== 1) throw new Error("");
        this.$store.commit("password/openFactorAuthent2", res.value === 1);
        this.isSetPwd2 = res.value === 1;
      } catch (e) {
        this.$store.commit("password/openFactorAuthent2", false);
        this.isSetPwd2 = false;
      } finally {
        this.loadingPwd2 = false;
      }
    },
    onClickSetPwd2() {
      this.$refs.editPwd2DialogRef.show(this.isSetPwd2);
    },
    onClickDelPwd2() {
      this.$refs.delPwd2DialogRef.show();
    },
    onClickEditAccount(type) {
      this.$refs.accountDialogRef.isType = type;
      this.$refs.accountDialogRef.dialogVisible = true;
      this.$refs.accountDialogRef.nickName = this.nickName;
    },
  },
};
</script>

<style scoped lang='less'>
.container_people {
  display: flex;
  justify-content: center;
  padding: 20px;
}
.accountInfo_box {
  width: 802px;
  height: 200px;
  margin-top: 52px;
  .account_title {
    font-size: 16px;
    color: #333;
    border-bottom: 1px solid #eee;
    margin-bottom: 65px;
  }
  .info_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 80px;
    i {
      color: #409eff;
      font-weight: bold;
      margin-right: 36px;
    }
    span:nth-of-type(1) {
      font-size: 14px;
      margin-right: 40px;
      width: 140px;
      display: inline-block;
    }
    span:nth-of-type(2) {
      font-size: 14px;
      color: #999;
    }
  }
  .del_btn {
    display: inline-block;
    font-size: 14px;
    color: #f56c6c;
    cursor: pointer;
    margin-left: 20px;
    &:hover {
      color: #f19898;
    }
  }
}
</style>